import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveTypeListPage } from '@/features/leaveTypes/pages/LeaveTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/leave-types')({
  beforeLoad: requireOfficeAccess,
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Leave Types">
      <Suspense fallback={<PageLoader />}>
        <LeaveTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
